import * as React from 'react'
import { useMemo } from 'react'
import { Props } from '../NameValue'
import { HighlightedText } from '@sales-center/components'
import Stack from '@mui/material/Stack'
import Box from '@mui/material/Box'
import { formatUSPhoneNumber } from '../../utils'
import { currencyString } from '@sales-center/common'

export function useData(props: Props) {
  const { highlightColor, searchText, value, variant, highlight } = props

  const valueFormatted = useMemo(() => {
    switch (variant) {
      case 'string': {
        return (
          <HighlightedText
            searchText={highlight ? searchText : ''}
            highlightColor={highlightColor}
            text={value}
          />
        )
      }
      case 'array': {
        return value?.length > 0 ? (
          <Stack direction="column">
            {value.map((v, i) => (
              <Box key={i}>{v}</Box>
            ))}
          </Stack>
        ) : (
          '\u00A0-'
        )
      }
      case 'phone': {
        return (
          <HighlightedText
            searchText={searchText}
            highlightColor={highlightColor}
            text={formatUSPhoneNumber(value)}
          />
        )
      }
      case 'currency': {
        return `$${currencyString(value)}`
      }
    }
  }, [highlightColor, searchText, value, variant])

  return { valueFormatted }
}
